import React, { useCallback, useEffect } from "react";

import { usePlayerStore } from "../store/usePlayerStore";

const getUiSizeInPx = async (element: Element): Promise<number> =>
  new Promise<number>(resolve => {
    const observer = new IntersectionObserver(nodes => {
      observer.disconnect();
      resolve(nodes[0].boundingClientRect.width);
    });
    observer.observe(element);
  });

export const UiSizeResolver = ({
  children,
  playerElement
}: {
  children: React.ReactNode;
  playerElement: HTMLElement;
}) => {
  const { useStoreState } = usePlayerStore();
  const setUiSize = useStoreState.setUiSize();

  const resolveUiSize = useCallback(async () => {
    setUiSize(await getUiSizeInPx(playerElement));
  }, [playerElement, setUiSize]);

  useEffect(() => {
    resolveUiSize();
    window.addEventListener("resize", resolveUiSize, false);

    return () => {
      window.removeEventListener("resize", resolveUiSize, false);
    };
  }, [resolveUiSize]);

  return children;
};
